module.exports = __webpack_public_path__ + "static/media/whatsapp_channel.67a50265.svg";